module.exports = __webpack_public_path__ + "static/media/vaccine_syringe.911da610.gif";